import React, { FC } from 'react';
import { map } from 'lodash';
import { NextStepButton, RequestStepContainer } from '../components';
import { useCurrentOffer } from 'logic/hooks/useCurrentOffer';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { TutoringType } from 'logic/api-models/tutoring-type';
import {
  RequestTutoringFields,
  useCurrentFormValues,
} from 'src/pages-all/details/tutor/components/RequestTutoringModal/request-tutoring-form.logic';
import { Text } from 'components/text/Text';
import { FormInputTutoringTypeBadges } from 'components/form-inputs/form-input-tutoring-type-badges/FormInputTutoringTypeBadges';

export const TutoringTypeStep: FC = () => {
  const { offer } = useCurrentOffer();
  const { teachingLocation } = useCurrentFormValues();
  const firstName = offer?.user?.firstName;
  const tutoringTypesAvailable = offer?.tutoringType?.filter(Boolean) as TutoringType[];
  const buttonDisabled = !teachingLocation?.length;

  const selectedTypes = map(teachingLocation) as TutoringType[];

  return (
    <RequestStepContainer
      title={translate(translationKeys.requestTutoringFlow.privateRequest, { firstName })}
    >
      <Text size={16}>{translate(translationKeys.requestTutoringFlow.whatLocation)}</Text>
      <FormInputTutoringTypeBadges
        fieldName={RequestTutoringFields.Location}
        selectedTypes={selectedTypes}
        tutoringTypesAvailable={tutoringTypesAvailable}
      />
      <NextStepButton disabled={buttonDisabled} />
    </RequestStepContainer>
  );
};
